// ================================================= /
// ======   Helpers JS   =========================== /
// ================================================= /

/**
 * Class for helpers
 */
class DispatchSkinHelpers {

	/**
	 * Determines if two elements' offsets intersect.
	 *
	 * Offset1 is the small one and offset2 is the big one
	 */
	doElementOffsetsIntersect( offset1, offset2, intersectionTolerance = 10 ) {

		if ( ! offset1 || ! offset2 ) {
			return false;
		}

		if (
			offset1.bottom - offset2.top > intersectionTolerance
			&& offset2.bottom - offset1.top > intersectionTolerance
		) {
			return true;
		}

		return false;
	}

}

const helpers = new DispatchSkinHelpers();
export default helpers;



// WEBPACK FOOTER //
// ./src/js/inc/helpers.js